import React, { Fragment, useMemo } from "react";
import { Card, CardBody, Col} from "reactstrap";
import { useTranslation } from "react-i18next";
import noImage from "../../assets/images/no-image.jpg";
import {
  COLOR_STICKER_PACKAGE_TYPE,
  STICKER_PACKAGE_TYPE_OPTION,
} from "helpers/constans";
import { truncate } from "utils";

interface TableContainerProps {
  item?: any;
  setLinkImage?: any;
  handleClickEdit?: any;
}

const TableGridPackageSticker = ({
  item,
  setLinkImage,
  handleClickEdit
}: TableContainerProps) => {
  const { t } = useTranslation();

  const noImage1 = useMemo(() => {
    return noImage;
  }, []);


  return (
    <Fragment>
      <Col md={2} lg={2} key={item?.original?.id}>
        <Card className="border">
          <CardBody style={{ position: "relative" }}>
            <div className="d-sm-flex">
              <div className="flex-grow-1">
                <div className="w-100 text-center ">
                  <div
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflow: "hidden",
                      height: "200px",
                    }}
                    className="m-auto cursor-pointer"
                    onClick={() => {
                      setLinkImage(item?.original?.thumbnailUrl);
                      document.body.className = "modal-open_img";
                    }}
                  >
                    <img
                      src={item?.original?.thumbnailUrl}
                      className="flex-shrink-0 rounded w-100 h-100"
                      alt="thumbnail"
                      style={{
                        maxHeight: "200px",
                        objectFit: "cover",
                      }}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = noImage1;
                      }}
                    />
                  </div>
                </div>

                <h5
                  className="cursor-pointer hover-underline my-3 text-primary"
                  onClick={() => handleClickEdit(item?.original)}
                >
                  { truncate(item?.original?.name, 30) }
                </h5>

                <div
                  className="d-flex align-items-center"
                  style={{
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    {item?.original?.type !== null && (
                      <span
                        className={`rounded-pill me-2 badge  bg-${
                          COLOR_STICKER_PACKAGE_TYPE[`${item?.original?.type || ""}`] ||
                          "success"
                        }-subtle text-${
                          COLOR_STICKER_PACKAGE_TYPE[`${item?.original?.type || ""}`] ||
                          "success"
                        }`}
                      >
                        {t(
                          STICKER_PACKAGE_TYPE_OPTION?.find(
                            (s) => String(s?.value) === String(item?.original?.type)
                          )?.label || ""
                        )}
                      </span>
                    )}
                  </div>

                  <div>
                    {t("Total Sticker")}:{" "}
                    <span className="text-danger">{item?.original?.stickerCount}</span>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default React.memo(TableGridPackageSticker);
